import { canManageClientDocument } from "../../utils/clientContactPermissions";
import { Select } from "antd";

const CreateContractContact = ({ client, contract, setContract }) => {
  const clientContactsArray = (client.contacts || []).filter((contact) => canManageClientDocument(contact, "contracts")).map((contact, idx) => {
    return {
      value: `${contact.firstname?.trim() || ""} ${
        contact.lastname?.trim() || ""
      } ${contact.email?.trim() || ""} ${contact.mobile?.trim() || ""}`,
      label: `${contact.firstname?.trim() || ""} ${
        contact.lastname?.trim() || ""
      } ${contact.email?.trim() || ""} ${contact.mobile?.trim() || ""}`,
      key: idx,
    };
  });

  return (
    <div className="flex flex-col h-full justify-between">
      <div>
        <p className="text-sm font-semibold text-left text-slate-900">Contact</p>

        <Select
          className="w-full mt-3"
          onChange={(e) => setContract({ ...contract, contact: e })}
          value={contract.contact ? `${contract.contact}` : null}
          optionFilterProp="children"
          placeholder="Contact"
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={clientContactsArray}
        />
      </div>
    </div>
  );
};

export default CreateContractContact;
